export const defaultSEI = () => ({ filterMode: "specific", uuidFilter: "", includeUuid: false });
export const normalizeSEI = (config = {}) => {
  const sei = config.sei && typeof config.sei === "object" ? config.sei : {};
  const uuidFilter = typeof sei.uuidFilter === "string" ? sei.uuidFilter.trim().toLowerCase() : "";
  return { filterMode: uuidFilter || config.payloadMode !== "h264Sei" ? "specific" : "any", uuidFilter, includeUuid: sei.includeUuid === true };
};
export const validateSEI = (sei) => sei.filterMode === "specific" && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sei.uuidFilter.trim())
  ? "Enter a valid UUID or choose Any UUID." : "";
export const seiPayload = (target) => target.type === "udp" && target.payloadMode === "h264Sei"
  ? { payloadMode: "h264Sei", sei: { ...(target.sei.filterMode === "specific" ? { uuidFilter: target.sei.uuidFilter.trim().toLowerCase() } : {}), includeUuid: target.sei.includeUuid === true } }
  : {};
export const clearSEIConfig = (config) => {
  const { payloadMode, sei, ...rest } = config;
  return rest;
};
